module.exports = "/css/fonts/nucleo-icons.woff?2569aaea6eaaf8cd210db7f2fa016743";